import { UserNotificationViewModel } from "@/models/Notification";

type DedupeInput = Pick<UserNotificationViewModel, "id"> & { ids?: number[] | null };

// A combined push has no user notification id of its own; it always arrives as 0. Keying it on the
// rows it stands for keeps a second, different combined push from being mistaken for the first.
export const notificationDedupeKey = (userNotification: DedupeInput): string =>
    userNotification.ids?.length
        ? `ids:${[...userNotification.ids].sort((a, b) => a - b).join(",")}`
        : `id:${userNotification.id}`;

export interface NotificationDeduper {
    /** True the first time a notification arrives within the window, false for a repeat. */
    claim(userNotification: DedupeInput): boolean;
}

export const createNotificationDeduper = (windowMs: number): NotificationDeduper => {
    const seen = new Set<string>();

    return {
        claim(userNotification: DedupeInput): boolean {
            const key = notificationDedupeKey(userNotification);
            if (seen.has(key)) return false;

            seen.add(key);
            setTimeout(() => seen.delete(key), windowMs);
            return true;
        }
    };
};
